import { makeAutoObservable, runInAction } from "mobx";
import { RootStore } from "../../shared/stores/RootStore";
import { CompositeCategory } from "../models/CompositeCategory";
import { MapMode } from "./MapStore";

export class MapQueryStore {
  rootStore;

  active = false;
  runningQuery = false;
  polygon?: number[][];
  compositeCategories: CompositeCategory[] = [];

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  resetState() {
    runInAction(() => {
      this.active = false;
      this.runningQuery = false;
      this.compositeCategories = [];
      this.polygon = undefined;
    });
  }

  activate() {
    runInAction(() => {
      this.active = true;
    });
    const { mapStore } = this.rootStore;
    mapStore.setMode(MapMode.ImportHlaBBox);
  }

  deactivate() {
    this.resetState();
    this.updateMapHighlights();
  }

  setPolygon(polygon: number[][] | undefined) {
    runInAction(() => {
      this.polygon = polygon;
    });
  }

  setCompositeCategories(value: CompositeCategory[]) {
    runInAction(() => {
      this.compositeCategories = value;
    });
    this.updateMapHighlights();
  }

  toggleCompositeCategory(name: string) {
    runInAction(() => {
      this.compositeCategories = this.compositeCategories.map((category) =>
        category.name === name
          ? {
              ...category,
              enabled: !category.enabled,
            }
          : category,
      );
    });

    this.updateMapHighlights();
  }

  updateMapHighlights() {
    const { mapStore } = this.rootStore;
    mapStore.importHlaMapSource?.highlightCategories(
      this.compositeCategories,
    );
  }

  setRunningQuery(value: boolean) {
    runInAction(() => {
      this.runningQuery = value;
    });
  }

  async importSelectedCategories() {
    const { mapStore } = this.rootStore;
    this.setRunningQuery(true);
    mapStore.importHlaMapSource
      ?.importSelectedCategories()
      .finally(() => {
        this.setRunningQuery(false);
      });
  }

  async importHlaFromAToB(route: GeoJSON.Position[]) {
    const { mapStore } = this.rootStore;
    this.setRunningQuery(true);
    mapStore.importHlaMapSource?.importFromAToB(route).finally(() => {
      this.setRunningQuery(false);
    });
  }
}
